import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { bibShape } from '@bibliocommons/bc-prop-types';

import BaseCancelHoldWorkflowView from './BaseCancelHoldWorkflowView';

export class BatchCancelHoldWorkflowView extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('handleCancelHold');
  }

  handleCancelHold({ shelfState }) {
    const { accountId, holdIds, bibs, messagingId, workflowId } = this.props;
    this.props.cancelHold({
      accountId,
      metadataIds: bibs
        .map((bib) => bib.get('metadataId'))
        .filter(metadataId => !this.props.shelves.has(metadataId)),
      holdIds,
      shelfState,
      messagingId,
      workflowId,
      isBatch: true
    });
  }

  anyBibNotOnShelf() {
    return this.props.bibs
      .map(bib => bib && bib.get('metadataId'))
      .some(metadataId => !this.props.shelves.has(metadataId));
  }

  render() {
    const { handleClose, accountId, holdIds, isLoading, done, bibs, messagingId, workflowId } = this.props;
    const showShelfPrompt = this.anyBibNotOnShelf();
    return (
      <div className="cp-batch-cancel-hold-view">
        <BaseCancelHoldWorkflowView
          handleCancelHold={this.handleCancelHold}
          handleClose={handleClose}
          accountId={accountId}
          holdIds={holdIds}
          isLoading={isLoading}
          done={done}
          bibs={bibs}
          messagingId={messagingId}
          showShelfPrompt={showShelfPrompt}
          workflowId={workflowId} />
      </div>
    );
  }
}

BatchCancelHoldWorkflowView.propTypes = {
  handleClose: PropTypes.func.isRequired,
  cancelHold: PropTypes.func.isRequired,
  accountId: PropTypes.number.isRequired,
  holdIds: ImmutablePropTypes.listOf(PropTypes.string),
  isLoading: PropTypes.bool,
  done: PropTypes.bool,
  bibs: ImmutablePropTypes.listOf(bibShape).isRequired,
  messagingId: PropTypes.string,
  workflowId: PropTypes.string,
  shelves: ImmutablePropTypes.map.isRequired
};

export default BatchCancelHoldWorkflowView;



// WEBPACK FOOTER //
// ./app/components/shared/ItemTransactions/components/cancel-hold-workflow-view/components/BatchCancelHoldWorkflowView.jsx